if (!customElements.get("media-displays")) {
  class ComponentMediaDisplays extends HTMLElement {
    constructor() {
      super();
      console.log("media displays");

      this.btn3dEl = this.querySelector(".btn-display-3d");
      this.btnGalleryEl = this.querySelector(".btn-display-gallery");
      this.btnVideoEl = this.querySelector(".btn-display-video");
      this.container3dEl = document.querySelector(
        `.${this.dataset.mediaViewer}`
      );
      this.containerGalleryEl = document.querySelector(
        `.${this.dataset.mediaGallery}`
      );
      this.containerVideoEl = document.querySelector(
        `.${this.dataset.mediaVideo}`
      );

      this.mode = this.dataset.defaultMode || "gallery";
      this.updateMediaDisplay();

      this.initBindings();
    }
    initBindings() {
      if (this.btn3dEl) {
        this.btn3dEl.addEventListener("click", (event) => {
          event.preventDefault();
          this.mode = "3d";
          this.updateMediaDisplay();
        });
      }
      if (this.btnGalleryEl) {
        this.btnGalleryEl.addEventListener("click", (event) => {
          event.preventDefault();
          this.mode = "gallery";
          this.updateMediaDisplay();
        });
      }
      if (this.btnVideoEl) {
        this.btnVideoEl.addEventListener("click", (event) => {
          event.preventDefault();
          this.mode = "video";
          this.updateMediaDisplay();
        });
      }
    }

    hideMediaDisplays() {
      this.btn3dEl.classList.remove("active");
      this.btnGalleryEl.classList.remove("active");
      this.btnVideoEl.classList.remove("active");
      this.container3dEl.classList.add("hide");
      this.containerGalleryEl.classList.add("hide");
      this.containerVideoEl.classList.add("hide");
    }

    updateMediaDisplay() {
      this.hideMediaDisplays();
      this[`btn${this.ucFirst(this.mode)}El`].classList.add("active");
      this[`container${this.ucFirst(this.mode)}El`].classList.remove("hide");
    }

    ucFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
  customElements.define("media-displays", ComponentMediaDisplays);
}
